import React from "react";
import Sidebar from "../Sidebar";
import Header from "../Header";
import BodyClass from "../../bodyClass";
import { Outlet } from 'react-router-dom';


const Layout = ({ props, children }) => {
    return (
        <div className="min-h-screen">
            <BodyClass />
            <Header />
            <Sidebar />
            <main className="relative z-0 pt-14 lg:pl-56">
                <div className="mx-auto max-w-[1200px] p-6">
                    <Outlet />
                    {children}
                </div>
            </main>
        </div>
    );
};

export default Layout;
